import script from "./DirectivesExercise.vue?vue&type=script&setup=true&lang=ts"
export * from "./DirectivesExercise.vue?vue&type=script&setup=true&lang=ts"

import "./DirectivesExercise.vue?vue&type=style&index=0&id=7ad1d43a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ad1d43a"]])

export default __exports__